import DiscountDetailsSFC from "./DiscountDetails.vue";
export const DiscountDetails = DiscountDetailsSFC;
